import { createSelector } from 'reselect';

import { fileComponentKey as cKey } from '../../helpers/reducers';
const componentsUploads = state => state.screens.components.uploads;
const editingObjectType = (state, props) => props.objectType;
const editingObjectId = (state, props) => props.objectId;
const files = state => state.entities.files;

export const getFileUploadStatusForEditingObject = createSelector(
  editingObjectType,
  editingObjectId,
  componentsUploads,
  (objectType, objectId, uploads) => {
    if (!objectId) return {};
    let fileCKey = cKey({
      objectType,
      objectId,
    });
    return uploads[fileCKey] || {};
  }
);

export const getFilesForEditingObject = createSelector(
  editingObjectType,
  editingObjectId,
  files,
  (objectType, objectId, files) => {
    if (!objectId) return [];
    let fileCKey = cKey({
      objectType,
      objectId,
    });

    return (files[fileCKey] && files[fileCKey].files) || [];
  }
);
